class CoverSelector extends HTMLElement {
  connectedCallback() {
    // scope queries to THIS instance
    this.bundleProductId = this.dataset.bundleProductId;
    this.dropdown        = this.querySelector('[data-cs="dropdown"]');
    this.swatchesWrap    = this.querySelector('[data-cs="swatches-wrap"]');
    this.swatches        = this.querySelectorAll('[data-cs="swatch"]');
    this.variantSelects  = this.querySelectorAll('[data-cs="variant-select"]');
    this.qtyWrap         = this.querySelector('[data-cs="qty-wrap"]');
    this.qtyDisplay      = this.querySelector('[data-cs="qty-display"]');
    this.qtyMinus        = this.querySelector('[data-cs="qty-minus"]');
    this.qtyPlus         = this.querySelector('[data-cs="qty-plus"]');
    this.errorMsg        = this.querySelector('[data-cs="error"]');
    this.addBtn          = this.querySelector('[data-cs="add"]');
    this.mainImg         = this.querySelector('[data-cs="main-img"]');

    this.selectedCover = null;
    this.selectedVariantId = null;
    this.coverQuantity = parseInt(this.qtyDisplay?.textContent || '2', 10);
    this.isSubmitting = false;

    if (!this.dropdown || !this.addBtn) return;

    // events
    this.dropdown.addEventListener('change', () => this.onDropdown());
    this.swatches.forEach(s => s.addEventListener('click', () => this.onSwatch(s)));
    this.variantSelects.forEach(sel => sel.addEventListener('change', e => this.onVariant(e)));
    this.qtyMinus?.addEventListener('click', () => this.changeQty(-1));
    this.qtyPlus?.addEventListener('click', () => this.changeQty(1));
    this.addBtn.addEventListener('click', () => this.addToCart());

    // initial state (important for quick-buy)
    this.onDropdown();
  }

  onDropdown() {
    const yes = this.dropdown.value === 'yes';
    this.swatchesWrap?.classList.toggle('visible', yes);
    if (this.qtyWrap) this.qtyWrap.style.display = yes ? 'block' : 'none';
    if (!yes) {
      this.selectedCover = null;
      this.selectedVariantId = null;
      this.clearSwatchSelection();
      this.hideError();
      this.resetMainImage();
    }
  }

  onSwatch(swatch) {
    this.clearSwatchSelection();
    swatch.classList.add('selected');

    this.selectedCover = {
      productId: swatch.dataset.productId,
      variantId: swatch.dataset.variantId,
      title:     swatch.dataset.productTitle,
      index:     swatch.dataset.coverIndex,
      productImage:    swatch.dataset.productImage,
      productImageAlt: swatch.dataset.productImageAlt
    };

    const wrapper = swatch.querySelector('[data-cs="variant-wrap"]');
    if (wrapper) {
      wrapper.classList.add('visible');
      const select = wrapper.querySelector('[data-cs="variant-select"]');
      if (select) {
        this.selectedVariantId = select.value;
        this.updateMainImageFromVariant(select);
      }
    } else {
      this.selectedVariantId = swatch.dataset.variantId;
      this.updateMainImageFromSwatch(swatch);
    }

    this.hideError();
  }

  onVariant(e) {
    const select = e.target;
    if (!this.selectedCover || this.selectedCover.index !== select.dataset.coverIndex) return;
    this.selectedVariantId = select.value;
    this.updateMainImageFromVariant(select);
  }

  updateMainImageFromSwatch(swatch) {
    if (!this.mainImg) return;
    const src = swatch.dataset.productImage;
    const alt = swatch.dataset.productImageAlt || swatch.dataset.productTitle;
    if (src) { this.mainImg.src = src; this.mainImg.alt = alt || ''; }
  }

  updateMainImageFromVariant(select) {
    if (!this.mainImg) return;
    const opt = select.options[select.selectedIndex];
    const src = opt.dataset.variantImage;
    const alt = opt.dataset.variantImageAlt || opt.textContent;
    if (src) { this.mainImg.src = src; this.mainImg.alt = alt || ''; }
    else if (this.selectedCover?.productImage) {
      this.mainImg.src = this.selectedCover.productImage;
      this.mainImg.alt = this.selectedCover.productImageAlt || this.selectedCover.title || '';
    }
  }

  resetMainImage() {
    if (!this.mainImg) return;
    const orig = this.mainImg.dataset.originalSrc;
    const alt  = this.mainImg.dataset.originalAlt;
    if (orig) { this.mainImg.src = orig; this.mainImg.alt = alt || ''; }
  }

  clearSwatchSelection() {
    this.swatches.forEach(s => {
      s.classList.remove('selected');
      const wrap = s.querySelector('[data-cs="variant-wrap"]');
      if (wrap) wrap.classList.remove('visible');
    });
  }

  changeQty(delta) {
    this.coverQuantity = Math.max(1, this.coverQuantity + delta);
    if (this.qtyDisplay) this.qtyDisplay.textContent = String(this.coverQuantity);
  }

  showError() { this.errorMsg?.classList.add('visible'); }
  hideError() { this.errorMsg?.classList.remove('visible'); }

  async addToCart() {
    if (this.isSubmitting) return;

    const addCovers = this.dropdown.value === 'yes';
    if (addCovers && !this.selectedCover) { this.showError(); return; }

    this.isSubmitting = true;
    this.addBtn.disabled = true;
    const original = this.addBtn.textContent;
    this.addBtn.textContent = 'Adding...';

    try {
      const items = [{ id: parseInt(this.bundleProductId, 10), quantity: 1 }];
      if (addCovers) {
        const id = parseInt(this.selectedVariantId || this.selectedCover?.variantId, 10);
        if (id) items.push({ id, quantity: this.coverQuantity });
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Failed to add to cart');

      window.location.href = '/cart';
    } catch (e) {
      alert('There was an error adding items to cart. Please try again.');
      console.error(e);
    } finally {
      this.isSubmitting = false;
      this.addBtn.disabled = false;
      this.addBtn.textContent = original;
    }
  }
}

if (!customElements.get('cover-selector')) {
  customElements.define('cover-selector', CoverSelector);
}

// Optional: present for quick-buy timing; not required because custom elements auto-upgrade.
document.addEventListener('quickbuy:loaded', () => {});
